// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarPanel_sidebar__3_s9t","header":"SidebarPanel_header__CODi6"};